import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 13.38 11.57"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "data-name": "Layer 2" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.17 11.5a.82.82 0 0 1-.79-.07.77.77 0 0 1-.38-.68v-2.6a.76.76 0 0 1 .18-.51 1.17 1.17 0 0 1 .42-.3l5.45-1.56L.6 4.21a1.09 1.09 0 0 1-.42-.31.73.73 0 0 1-.18-.5V.84A.78.78 0 0 1 .38.15a.8.8 0 0 1 .79-.08L12.86 5a.79.79 0 0 1 .52.79.75.75 0 0 1-.52.77Z",
    "data-name": "notities"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }